const PREFIX = '/_assets/images/icons/';

export const ICONS = {
  'check': {
    src: `${PREFIX}check.svg`,
    alt: '✅',
  },
  'copy': {
    src: `${PREFIX}copy.svg`,
    alt: '📋',
  },
  'credit-card': {
    src: `${PREFIX}credit-card.svg`,
    alt: '💳',
  },
  'document': {
    src: `${PREFIX}document.svg`,
    alt: '📄',
  },
  'edit': {
    src: `${PREFIX}edit.svg`,
    alt: '✏️',
  },
  'error': {
    src: `${PREFIX}error.svg`,
    alt: '❌',
  },
  'exit': {
    src: `${PREFIX}exit.svg`,
    alt: '🚶',
  },
  'folder': {
    src: `${PREFIX}folder.svg`,
    alt: '📁',
  },
  'plus': {
    src: `${PREFIX}plus.svg`,
    alt: '➕',
  },
  'preview': {
    src: `${PREFIX}preview.svg`,
    alt: '👁️',
  },
  'restore': {
    src: `${PREFIX}restore.svg`,
    alt: '↩️',
  },
  'settings': {
    src: `${PREFIX}settings.svg`,
    alt: '⚙️',
  },
  'palette': {
    src: `${PREFIX}palette.svg`,
    alt: '🎨',
  },
  'shield': {
    src: `${PREFIX}shield.svg`,
    alt: '🔒',
  },
  'tools': {
    src: `${PREFIX}tools.svg`,
    alt: '🔧',
  },
  'trash': {
    src: `${PREFIX}trash.svg`,
    alt: '🗑️',
  },
  'upload': {
    src: `${PREFIX}upload.svg`,
    alt: '⬆️',
  },
  'warning': {
    src: `${PREFIX}warning.svg`,
    alt: '⚠️',
  },
  'fork': {
    src: `${PREFIX}fork.svg`,
    alt: '🍴',
  },
  'history': {
    src: `${PREFIX}history.svg`,
    alt: '⏰',
  },
  'info': {
    src: `${PREFIX}info.svg`,
    alt: 'ℹ️',
  },
  'hamburger': {
    src: `${PREFIX}hamburger.svg`,
    alt: '☰',
  },
  'toc': {
    src: `${PREFIX}toc.svg`,
    alt: '📋',
  },
  'map': {
    src: `${PREFIX}map.svg`,
    alt: '🗺️',
  },
};